var map = {
	"./bccsa/logoSimple.png": 1613,
	"./cressey/logoSimple.png": 1614,
	"./csam/logoSimple.png": 1615,
	"./goldenacorn/logoSimple.png": 1616,
	"./ibew/logoSimple.png": 1617,
	"./orangepiggy/logoSimple.png": 1618,
	"./wgplangrid/logoSimple.png": 1619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1612;